import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  HostListener,
  OnInit,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Event, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ConsoleComponent, SceneLauncherComponent } from '@components';
import { environment } from '@environment';
import { AppService, DataService } from '@services';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'bo-app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ConsoleComponent,
    DialogModule,
    RouterOutlet,
    SceneLauncherComponent,
  ],
})
export class AppComponent implements OnInit {
  @HostListener('touchend', ['$event'])
  onTouchEnd(event: TouchEvent) {
    const now = new Date().getTime();
    if (now - this.lastTouchEnd <= 300) {
      event.preventDefault(); // Prevent the default zoom behavior
    }

    this.lastTouchEnd = now;
  }
  lastTouchEnd = 0;

  protected appService = inject(AppService);
  public dataService = inject(DataService);
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);

  hidePortraitModeWarning = signal(false);

  date = new Date();

  versionInfo = environment.version;

  ngOnInit(): void {
    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          history.pushState(null, null, window.location.href);
        }
      });
    sessionStorage.clear();
  }
}
